import React, {Component} from 'react';
import {HashRouter, Route, Switch, withRouter} from 'react-router-dom';
import Left from './component/common/left';
import NProgress from 'nprogress';
import {connect} from 'react-redux';
import {LoginAction} from './component/login/actions';
import 'nprogress/nprogress.css';
import Headers from './component/common/header';
import Errors from './component/error';
import routerMap from './routers/routerMap';
import {hasToken,recommendBrowser, Utils} from './tools/utils';
import {notification} from 'antd';
import AuthenticatedPage from './component/auth/authenticated-page';
import JDLogin from './component/login/jdLogin';
import Login from './component/login';

NProgress.configure({showSpinner: false});

class Pages extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showLeft: false,
            pageHeight: (window.document.documentElement.clientHeight) || (window.document.body.clientHeight)
        };
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.location.pathname !== nextProps.location.pathname) {
            this.props.setPathName(nextProps.location.pathname);
            const pathname = nextProps.location.pathname ? nextProps.location.pathname.toLowerCase() : '';
            if (pathname === '/login'|| pathname === '/jdlogin'|| pathname === '/newlogin' || pathname.indexOf('login') >= 0) {
                hasToken() && this.props.history.push('/homePage');//登录状态下不允许用户进入登录页
                this.setState({showLeft: false});
            } else if (!this.state.showLeft) {
                this.setState({showLeft: true});
            }
            NProgress.start();
            Utils.sensorsAutoTrack();
        } else {
            NProgress.done();
        }
    }

    componentWillMount() {
        this.props.setPathName(this.props.location.pathname);
        NProgress.start();
        this.props.getToken();
        this.recommendBrowser();
    }

    componentDidMount() {
        NProgress.done();
        const pathname = this.props.location.pathname ? this.props.location.pathname.toLowerCase() : '';
        if (pathname === '/login' || pathname === '/jdlogin' || pathname === '/newlogin' || pathname.indexOf('login') >= 0) {
            hasToken() && this.props.history.push('/homePage');//登录状态下不允许用户进入登录页
            this.setState({showLeft: false});
        } else {
            this.setState({showLeft: true});
        }
        window.onhashchange = () => {
            NProgress.done();
        };
        window.onresize = () => {
            this.setState({
                pageHeight: (window.document.documentElement.clientHeight) || (window.document.body.clientHeight)
            });
        };
    }
    // 推荐浏览器
    recommendBrowser = () => {
        if (!recommendBrowser()) {
            notification.open({
                message: <div style={{display: 'flex', alignItems: 'center'}}>
                    <div>
                        <img src={window.location.origin + window.location.pathname + 'chrome.svg'} alt=''
                            style={{width: 32, height: 32}}
                        />
                        <span style={{color: '#999', fontSize: 14, marginLeft: 8}}>Chrome浏览器</span>
                    </div>
                    <div style={{marginLeft: 16}}>
                        <img src={window.location.origin + window.location.pathname + 'firefox.svg'} alt=''
                            style={{width: 32, height: 32}}
                        />
                        <span style={{color: '#999', fontSize: 14, marginLeft: 8}}>FireFox浏览器</span>
                    </div>

                </div>,
                description:'我们推荐您使用以上浏览器，完美支持保险管理平台',
                duration: 0
            });
        }
    };
    render() {
        return (
            <div style={{
                minHeight: this.state.pageHeight,
                position:'relative',
                boxSizing: 'border-box',
                paddingLeft: this.state.showLeft ? '250px' : '0px'
            }}>
                {
                    this.state.showLeft && <Left/>
                }
                <div style={{
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    position: 'relative',
                    minHeight: this.state.pageHeight
                }}>
                    {
                        this.state.showLeft && <Headers/>
                    }

                    <HashRouter>
                        <Switch>
                            <Route key={2} exact path='/newLogin' component={Login}/>,
                            <Route key={3} path='/login' component={Login}/>,
                            <Route key={4} exact path='/jdLogin' component={JDLogin}/>,
                            <Route path="/">
                                <AuthenticatedPage>
                                    <Switch>
                                        {
                                            routerMap.map((router, index) => {
                                                return router;
                                            })
                                        }
                                        <Route component={Errors}/>
                                    </Switch>
                                </AuthenticatedPage>
                            </Route>
                        </Switch>
                    </HashRouter>
                </div>
            </div>
        );
    }
}

function mapState(state) {
    return {
        token: state.token,
        pathName: state.pathName
    };
}

function mapDispatchtoProps() {
    return {
        ...LoginAction,
        setPathName: function (val) {
            // console.log(val)
            return {
                type: 'setPathName',
                payload: val
            };
        }
    };
}

export default withRouter(connect(mapState, mapDispatchtoProps())(Pages));
